import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { AngularMaterialModule } from '../_Modules/angular.material.module';

import { ButtonComponent } from './buttons/button/button.component';
import { H1Component } from './typography/h1/h1.component';
import { H2Component } from './typography/h2/h2.component';
import { H3Component } from './typography/h3/h3.component';
import { H4Component } from './typography/h4/h4.component';
import { TextLargeComponent } from './typography/text-large/text-large.component';
import { TextMediumComponent } from './typography/text-medium/text-medium.component';
import { TextSmallComponent } from './typography/text-small/text-small.component';
import { BodyLargeComponent } from './typography/body-large/body-large.component';
import { BodyMediumComponent } from './typography/body-medium/body-medium.component';
import { BodySmallComponent } from './typography/body-small/body-small.component';
import { InputComponent } from './inputs/input/input.component';
import { DatePickerComponent } from './inputs/date-picker/date-picker.component';
import { SearchComponent } from './inputs/search/search.component';
import { TextareaComponent } from './inputs/textarea/textarea.component';
import { DropdownComponent } from './inputs/dropdown/dropdown.component';
import { MultiSelectComponent } from './inputs/multi-select/multi-select.component';
import { TagsComponent } from './tags/tags.component';
import { LabelComponent } from './label/label.component';
import { BadgeComponent } from './badge/badge.component';
import { PaginationPageComponent } from './paginator/pagination-page/pagination-page.component';
import { PaginationDotComponent } from './paginator/pagination-dot/pagination-dot.component';
import { RatingComponent } from './rating/rating.component';
import { LoaderComponent } from './loaders/loader/loader.component';
import { ProgressComponent } from './loaders/progress/progress.component';
import { GhostLoaderComponent } from './loaders/ghost/index';
import { AvatarComponent } from './avatar/avatar.component';
import { TableComponent } from './table';
import { FiltersComponent } from './filters';
import { QuickFiltersComponent } from './quick-filters';
import { ModalComponent } from './modal/modal.component';
import { UploaderComponent } from './uploader/uploader.component';
import { SelectAllComponent } from './select-all/select-all.component';
import { AlertComponent } from './alert/alert.component';
import { LoanCardComponent } from './loan-card/loan-card.component';
import { OfferCardComponent } from './offer-card/offer-card.component';
import { TableDefaultComponent } from './table-default/table-default.component';
import { FormComponent } from './form/form.component';

const commonCompnents = [
  ButtonComponent,
  H1Component,
  H2Component,
  H3Component,
  H4Component,
  TextLargeComponent,
  TextMediumComponent,
  TextSmallComponent,
  BodyLargeComponent,
  BodyMediumComponent,
  BodySmallComponent,
  InputComponent,
  DatePickerComponent,
  SearchComponent,
  TextareaComponent,
  DropdownComponent,
  MultiSelectComponent,
  PaginationPageComponent,
  PaginationDotComponent,
  QuickFiltersComponent,
  FiltersComponent,
  LoaderComponent,
  ProgressComponent,
  GhostLoaderComponent,
  AlertComponent,
  UploaderComponent,
  ModalComponent,
  TableComponent,
  TableDefaultComponent,
  FormComponent,
  TagsComponent,
  LabelComponent,
  BadgeComponent,
  RatingComponent,
  AvatarComponent,
  SelectAllComponent,
  LoanCardComponent,
  OfferCardComponent,
];

@NgModule({
  declarations: commonCompnents,
  imports: [CommonModule, AngularMaterialModule],
  exports: commonCompnents,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
